import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnInit {
  @Input() totalNumberOfRecords: number;
  @Output() pageEvent = new EventEmitter<object>();

  constructor() {}

  ngOnInit() {}

  onPageSizeOrPageIndexChange(e) {
    this.pageEvent.emit({
      page: e.pageIndex,
      size: e.pageSize
    });
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/admin/components/shared/paginator/paginator.component.ts